<template>
  <div
    class="tw-p-2 tw-border tw-col-span-2 tw-border-primary tw-border-solid tw-rounded-xl"
  >
    <h3 class="tw-text-text tw-text-lg tw-mb-2">اضافة / تعديل ميزة</h3>
    <div
      class="tw-p-2 tw-border tw-border-solid tw-rounded-xl tw-mb-2 last:tw-mb-0"
      v-for="(feature, index) in features"
      :key="index"
    >
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2 tw-mt-3">
        <ValidationProvider
          setInteractionMode="eager"
          v-slot="{ errors }"
          :name="index + '-' + $t('labels.title') + $t('inArabic')"
          rules="required"
        >
          <div class="input_wrapper">
            <label for="title_ar">{{
              $t("labels.title") + $t("inArabic")
            }}</label>

            <app-input
              @input="updateValue"
              v-model="feature.title_ar"
              id="title_ar"
              type="text"
              :placeholder="$t('labels.title') + $t('inArabic')"
              :name="index + '-' + $t('labels.title') + $t('inArabic')"
            ></app-input>
          </div>
          <span v-if="errors[0]" class="error--text d-inline-block">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          :name="index + '-' + $t('labels.title') + $t('inEnglish')"
          rules="required"
        >
          <div class="input_wrapper">
            <label for="title_en">{{
              $t("labels.title") + $t("inEnglish")
            }}</label>

            <app-input
              @input="updateValue"
              id="title_en"
              v-model="feature.title_en"
              type="text"
              :placeholder="$t('labels.title') + $t('inEnglish')"
              :name="index + '-' + $t('labels.title') + $t('inEnglish')"
            ></app-input>
          </div>
          <span v-if="errors[0]" class="error--text d-inline-block">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <template v-if="data.desc">
          <ValidationProvider
            setInteractionMode="eager"
            v-slot="{ errors }"
            :name="index + '-' + $t('labels.desc') + $t('inArabic')"
            rules="required"
          >
            <div class="input_wrapper">
              <label for="desc_ar">{{
                $t("labels.desc") + $t("inArabic")
              }}</label>

              <app-input
                @input="updateValue"
                v-model="feature.desc_ar"
                id="desc_ar"
                type="text"
                :name="index + '-' + $t('labels.desc') + $t('inArabic')"
                :placeholder="$t('labels.desc') + $t('inArabic')"
              ></app-input>
            </div>
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('labels.desc') + $t('inEnglish') + index + 1"
            rules="required"
          >
            <div class="input_wrapper">
              <label for="desc_en">{{
                $t("labels.desc") + $t("inEnglish")
              }}</label>

              <app-input
                @input="updateValue"
                v-model="feature.desc_en"
                id="desc_en"
                type="text"
                :placeholder="$t('labels.desc') + $t('inEnglish')"
                :name="$t('labels.desc') + $t('inEnglish') + index + 1"
              ></app-input>
            </div>
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </template>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2 tw-justify-end pt-2">
        <button
          class="base-btn tw-py-1 tw-px-2"
          type="button"
          @click="addSections(index)"
        >
          <i class="fas fa-plus"> </i>
        </button>
        <button
          class="base-btn-white tw-py-1 tw-px-2"
          type="button"
          v-if="features.length > 1"
          @click="deleteSection(index)"
        >
          <i class="fas fa-minus"> </i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    data: {
      required: false,
    },
  },
  data() {
    return {
      features: [
        {
          title_ar: "",
          title_en: "",
          desc_ar: "",
          desc_en: "",
        },
      ],

      btnLoading: false,
    };
  },

  methods: {
    addSections(i) {
      const item = {
        title_ar: "",
        title_en: "",
        desc_ar: "",
        desc_en: "",
      };

      this.features.splice(i + 1, 0, item);
    },
    deleteSection(i) {
      this.features.splice(i, 1);
    },
    updateValue() {
      this.$emit("input", this.features);
    },
  },
};
</script>

<style></style>
